import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#warning-clip0_2249_849)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "m12 3.342 9.198 17.63H2.802zM.121 21.54 11.063.57a1.057 1.057 0 0 1 1.874 0l10.942 20.97a1.057 1.057 0 0 1-.937 1.546H1.059A1.057 1.057 0 0 1 .12 21.54M12 16.743a1.057 1.057 0 0 0 0 2.114h.01a1.057 1.057 0 0 0 0-2.114zm0-8.457c.584 0 1.057.473 1.057 1.057v4.228a1.057 1.057 0 1 1-2.114 0V9.343c0-.584.473-1.057 1.057-1.057",
        "clip-rule": "evenodd"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "warning-clip0_2249_849" }, [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }